<template>
    <v-dialog
        v-model="internalDialog"
        max-width="700"
        persistent
    >
        <v-card class="background-2 round-card">
            <v-card-title class="warning white--text">
                <v-icon left color="white">mdi-alert</v-icon>
                Attenzione: possibile anomalia cronologica
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="pt-4">
                <p class="body-1 mb-3">
                    Il numero e la data del documento potrebbero non essere in ordine cronologico
                    rispetto ad altri documenti dello stesso sezionale.
                </p>

                <div v-if="hasConflicts" class="mt-4">
                    <!-- Future conflicts: higher numbers with earlier dates -->
                    <div v-if="futureConflicts.length > 0" class="mb-4">
                        <div class="subtitle-2 error--text mb-2">
                            <v-icon small color="error">mdi-arrow-up</v-icon>
                            Documenti con numero maggiore ma data precedente:
                        </div>
                        <v-simple-table dense class="mb-2">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Numero</th>
                                        <th>Data</th>
                                        <th v-if="futureConflicts[0] && futureConflicts[0].business_name">Cliente</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="conflict in futureConflicts" :key="'future-' + conflict.id">
                                        <td class="font-weight-bold">{{ conflict.number }}</td>
                                        <td>{{ formatDate(conflict.date) }}</td>
                                        <td v-if="conflict.business_name">{{ conflict.business_name }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </div>

                    <!-- Past conflicts: lower numbers with later dates -->
                    <div v-if="pastConflicts.length > 0" class="mb-4">
                        <div class="subtitle-2 error--text mb-2">
                            <v-icon small color="error">mdi-arrow-down</v-icon>
                            Documenti con numero minore ma data successiva:
                        </div>
                        <v-simple-table dense class="mb-2">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Numero</th>
                                        <th>Data</th>
                                        <th v-if="pastConflicts[0] && pastConflicts[0].business_name">Cliente</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="conflict in pastConflicts" :key="'past-' + conflict.id">
                                        <td class="font-weight-bold">{{ conflict.number }}</td>
                                        <td>{{ formatDate(conflict.date) }}</td>
                                        <td v-if="conflict.business_name">{{ conflict.business_name }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </div>
                </div>

                <v-alert
                    type="info"
                    border="left"
                    colored-border
                    dense
                    class="mt-4 mb-0"
                >
                    <div class="caption">
                        Questa è solo una verifica di coerenza. Puoi procedere se sei sicuro che
                        numero e data siano corretti.
                    </div>
                </v-alert>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    text
                    @click="handleCancel"
                >
                    Annulla
                </v-btn>
                <v-btn
                    color="primary"
                    @click="handleConfirm"
                >
                    Procedi comunque
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ChronologyWarningDialog',

    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        conflicts: {
            type: Object,
            default: () => ({
                future: [],
                past: []
            })
        }
    },

    computed: {
        internalDialog: {
            get() {
                return this.dialog
            },
            set(value) {
                this.$emit('update:dialog', value)
            }
        },

        futureConflicts() {
            return (this.conflicts && this.conflicts.future) || []
        },

        pastConflicts() {
            return (this.conflicts && this.conflicts.past) || []
        },

        hasConflicts() {
            return this.futureConflicts.length > 0 || this.pastConflicts.length > 0
        }
    },

    methods: {
        formatDate(date) {
            if (!date) return ''
            const d = new Date(date)
            const day = String(d.getDate()).padStart(2, '0')
            const month = String(d.getMonth() + 1).padStart(2, '0')
            const year = d.getFullYear()
            return `${day}/${month}/${year}`
        },

        handleConfirm() {
            this.$emit('confirm')
            this.internalDialog = false
        },

        handleCancel() {
            this.$emit('cancel')
            this.internalDialog = false
        }
    }
}
</script>

<style scoped>
.v-data-table >>> tbody tr {
    cursor: default;
}
</style>
